var map = {
	"./status_-1.png": "c78d",
	"./status_0.png": "801a",
	"./status_1.png": "b213",
	"./status_2.png": "776b",
	"./status_3.png": "0929",
	"./status_4.png": "ac42",
	"./status_5.png": "037b",
	"./status_6.png": "c482",
	"./status_7.png": "3d89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad23";